<template>
    <div>
        <div
            v-for="(part, partIndex) in message.split('. ')"
            :key="partIndex"
            class="mr-7.5 text-xs text-gray-370 dark:text-white break-words"
            :class="{ 'mb-2': !partIndex }"
        >
            {{ part }}
        </div>

        <div
            v-for="uuid in uuids"
            :key="uuid"
            class="flex items-center gap-x-1 mt-1 mr-7.5 group"
            @click.stop="copyUuid(uuid)"
        >
            <span class="text-xs text-gray-280 dark:text-gray-190 group-hover:text-purple break-all">{{ uuid }}</span>

            <CopyIcon class="w-4 h-4 max-md:min-w-6 max-md:h-6 text-gray-280 dark:text-gray-200 group-hover:text-purple"/>
        </div>
    </div>
</template>

<script setup>
import CopyIcon from '@/components/icons/CopyIcon.vue'

import { copyInStash } from '@/helpers/app-helper'

import { useDefaultStore } from '@/store/defaultStore'

defineProps({
    uuids: {
        type: Array,
        default: () => [],
    },
    message: {
        type: String,
        default: '',
    },
})

const defaultStore = useDefaultStore()

async function copyUuid(uuid) {
    copyInStash(uuid)

    defaultStore.setInfoMessage({ message: 'Successful copy' })
}
</script>
